import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import type { WizardContext } from '@swf/core/types/Wizard';

import useEkycTransitionScreenCheck from '../../../../hooks/useEkycTransitionScreenCheck';
import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import RMFEKYCTransitionScreen from '../RMFEKYCTransitionScreen/RMFEKYCTransitionScreen';

import DataSummary from './DataSummary/DataSummary';
import {
  TXTCLI_Confirm,
  TXTWCL_Please_check_that_your_persona_ELL,
  TXTWCL_We_are_having_trouble_verifyin_ELL
} from './RMFSummaryScreen.messages.json';

const RMFSummaryScreen: React.FC = () => {
  const {
    values: { firstName, middleName, lastName }
  }: WizardContext = useWizardContext();
  const fullName = [firstName, middleName, lastName].filter(Boolean).join(' ');
  const shouldShowEKYCTransition = useEkycTransitionScreenCheck();
  return (
    <Container
      page={RMFSummaryScreen}
      headerProps={{
        title: fullName,
        buttons: { back: false }
      }}
      pageTopTitle={<Translation {...TXTWCL_We_are_having_trouble_verifyin_ELL} />}
      pageTopSubtitle={<Translation {...TXTWCL_Please_check_that_your_persona_ELL} />}
    >
      {shouldShowEKYCTransition && <RMFEKYCTransitionScreen transitionType="checkDetails" />}
      <DataSummary />
      <CTAButton translation={TXTCLI_Confirm} />
    </Container>
  );
};

RMFSummaryScreen.displayName = 'RMFSummaryScreen';

export default RMFSummaryScreen;
